<div class="cx-summary-partials" *ngIf="cart">
  <div class="cx-summary-row" *ngIf="cart.subTotal?.formattedValue">
    <div class="cx-summary-label">товары</div>
    <div class="cx-summary-amount">
      {{ cart.subTotal?.formattedValue }}
    </div>
  </div>
  <div *ngIf="cart.deliveryCost?.value" class="cx-summary-row">
    <div class="cx-summary-label">доставка</div>
    <div class="cx-summary-amount">
      {{ cart.deliveryCost.formattedValue }}
    </div>
  </div>

  <div *ngIf="cart.deliveryServicesCost?.value" class="cx-summary-row">
    <div class="cx-summary-label">доп. услуги</div>
    <div class="cx-summary-amount">
      {{ cart.deliveryServicesCost.formattedValue }}
    </div>
  </div>

  <div class="cx-summary-row" *ngIf="cart.totalDiscounts?.value">
    <div class="cx-summary-label">скидка</div>
    <div class="cx-summary-amount">- {{ cart.totalDiscounts?.formattedValue }}</div>
  </div>

  <div class="cx-summary-row" *ngIf="cart.totalBonusDiscounts?.value">
    <div class="cx-summary-label">баллы</div>
    <div class="cx-summary-amount">- {{ cart.totalBonusDiscounts.formattedValue }}</div>
  </div>

  <div class="cx-summary-row cx-summary-total" *ngIf="cart.totalPriceWithTax?.formattedValue">
    <div class="cx-summary-label-total">итого</div>
    <div class="cx-summary-amount-total">
      {{ cart.totalPriceWithTax?.formattedValue }}
    </div>
  </div>
</div>
